import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { toast } from "sonner";

const inputCls = "w-full px-4 py-3 border border-[var(--line)] focus:border-[var(--accent)] outline-none text-sm";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devUrl, setDevUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.dev_reset_url) setDevUrl(data.dev_reset_url);
      toast.success("If that email exists, a reset link has been sent.");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Forgot password" subtitle="We'll email you a reset link.">
      {sent ? (
        <div className="border border-[var(--line)] p-6 bg-white text-center" data-testid="forgot-sent">
          <p className="text-sm text-[var(--ink-2)] mb-4">If an account exists for <strong>{email}</strong>, a reset link is on its way.</p>
          {devUrl && <a href={devUrl} data-testid="dev-reset-link" className="inline-block bg-[var(--accent)] text-white font-semibold px-6 py-3">Reset password now</a>}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <input data-testid="forgot-email" type="email" required placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <button disabled={loading} data-testid="forgot-submit" className="w-full bg-[var(--accent)] text-white font-semibold py-3.5 hover:bg-[var(--accent-hover)] disabled:opacity-60">{loading ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
      <p className="mt-5 text-sm text-center"><Link to="/login" className="text-[var(--ink-2)] hover:text-[var(--ink)]">Back to login</Link></p>
    </AuthShell>
  );
}
